import { BookingTag } from "../types/VenueGroup";

export type GridItem = {
  fields: BookingTag[];
  isCheckboxGroup: boolean;
  colSpan: number;
};

export const buildGridLayout = (
  visibleFields: BookingTag[],
  cols: number
): GridItem[][] => {
  const isBooleanOrMultiselect = (field: BookingTag): boolean =>
    field.type === "boolean" || field.type === "multiselect";

  const items: Array<{
    fields: BookingTag[];
    isCheckboxGroup: boolean;
  }> = [];

  let checkboxGroup: BookingTag[] = [];

  const flushCheckboxGroup = () => {
    if (checkboxGroup.length > 0) {
      items.push({ fields: [...checkboxGroup], isCheckboxGroup: true });
      checkboxGroup = [];
    }
  };

  visibleFields.forEach((field) => {
    if (isBooleanOrMultiselect(field)) {
      checkboxGroup.push(field);
    } else {
      flushCheckboxGroup();
      items.push({ fields: [field], isCheckboxGroup: false });
    }
  });
  flushCheckboxGroup();

  const rows: GridItem[][] = [];
  let currentRow: GridItem[] = [];
  let currentCols = 0;

  items.forEach((item) => {
    const baseSpan = item.isCheckboxGroup
      ? Math.min(item.fields.length, cols)
      : 1;

    if (currentCols + baseSpan > cols) {
      rows.push(currentRow);
      currentRow = [];
      currentCols = 0;
    }

    currentRow.push({ ...item, colSpan: baseSpan });
    currentCols += baseSpan;

    if (currentCols >= cols) {
      rows.push(currentRow);
      currentRow = [];
      currentCols = 0;
    }
  });

  if (currentRow.length > 0) {
    rows.push(currentRow);
  }

  if (rows.length > 0) {
    const lastRow = rows[rows.length - 1];
    const usedCols = lastRow.reduce((sum, item) => sum + item.colSpan, 0);
    if (usedCols < cols && lastRow.length > 0) {
      const extraPerItem = Math.floor((cols - usedCols) / lastRow.length);
      const remainder = (cols - usedCols) % lastRow.length;
      lastRow.forEach((item, idx) => {
        item.colSpan += extraPerItem + (idx < remainder ? 1 : 0);
      });
    }
  }

  return rows;
};
